import React from 'react';
import './Spinner.scss';

export default () => (
  <div className="spinner-wrapper">
    <div className="spinner" />
  </div>
);
